@let serviceRequests = $serviceRequests | async;
<!---->
@let serviceRequestsFetchedAt = $serviceRequestsFetchedAt | async;
<!---->

<div class="d-flex justify-content-end mb-3">
  <button mat-raised-button color="primary" (click)="onRecreateServiceRequest()">
    Recreate Service Request
  </button>
</div>

<mat-card>
  @if (serviceRequestsFetchedAt) {
  <app-service-requests-table
    [serviceRequests]="serviceRequests ?? []"
  ></app-service-requests-table>
  } @else {
  <div class="my-3 d-flex justify-content-center">
    <mat-progress-spinner diameter="30" mode="indeterminate" color="primary">
    </mat-progress-spinner>
  </div>
  }
</mat-card>
